
/* eslint-disable */
<template>
  <div id="app">
  <div class="global-wrapper clearfix" id="global-wrapper">
        <HeaderMenu />
			<MainMenu />
      <router-view />
      	<div class="gap"></div>
        </div>
       <Footer/>
        <div class="copyright-area">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <p class="copyright-text">Copyright &copy; <a href="#">Toolaku</a> 2019. All rights reseved</p>
                    </div>
                    <div class="col-md-6">
                        <!--<ul class="payment-icons-list">
                            <li>
                                <img src="@/assets/img/payment/visa-straight-32px.png" alt="Image Alternative text" title="Pay with Visa" />
                            </li>
                            <li>
                                <img src="@/assets/img/payment/mastercard-straight-32px.png" alt="Image Alternative text" title="Pay with Mastercard" />
                            </li>
                            <li>
                                <img src="@/assets/img/payment/paypal-straight-32px.png" alt="Image Alternative text" title="Pay with Paypal" />
                            </li>
                            <li>
                                <img src="@/assets/img/payment/visa-electron-straight-32px.png" alt="Image Alternative text" title="Pay with Visa-electron" />
                            </li>
                            <li>
                                <img src="@/assets/img/payment/maestro-straight-32px.png" alt="Image Alternative text" title="Pay with Maestro" />
                            </li>
                            <li>
                                <img src="@/assets/img/payment/discover-straight-32px.png" alt="Image Alternative text" title="Pay with Discover" />
                            </li>
                        </ul>-->
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import Footer from '@/components/Footer'
import HeaderMenu from '@/components/HeaderMenu'
import MainMenu from '@/components/MainMenu'


export default {
  name: 'App',
  components: {
    Footer,
		HeaderMenu,
    MainMenu
		},
  data: () => ({
    drawer: false
  }),
  methods: {
    logout() {
   
    }
  }
}
</script>
